import React from 'react';
import { Stack, Typography } from '@mui/material';
import { colors } from '../../Themes/colors';
var CommonHeader = function (_a) {
    var icon = _a.icon, mainTitle = _a.mainTitle, subTitle = _a.subTitle, _b = _a.iconColor, iconColor = _b === void 0 ? colors.creamPreset[10] : _b, _c = _a.iconBgColor, iconBgColor = _c === void 0 ? colors.creamPreset[20] : _c, _d = _a.iconSize, iconSize = _d === void 0 ? 24 : _d, _e = _a.iconPadding, iconPadding = _e === void 0 ? 2.25 : _e, _f = _a.mainTitleFS, mainTitleFS = _f === void 0 ? 24 : _f, _g = _a.subTitleFS, subTitleFS = _g === void 0 ? 16 : _g, _h = _a.cardGap, cardGap = _h === void 0 ? 2 : _h, _j = _a.iconBorderRadius, iconBorderRadius = _j === void 0 ? 3 : _j, _k = _a.mainTitleNoWrap, mainTitleNoWrap = _k === void 0 ? false : _k;
    return (React.createElement(Stack, { gap: cardGap, direction: "row", alignItems: "center" },
        icon && (React.createElement(Stack, { sx: {
                borderRadius: iconBorderRadius,
                bgcolor: iconBgColor,
                p: iconPadding,
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'fit-content',
            } }, icon)),
        React.createElement(Stack, { gap: 1 },
            React.createElement(Typography, { variant: "h4", fontWeight: 600, color: 'textPrimary', fontSize: mainTitleFS, noWrap: mainTitleNoWrap }, mainTitle),
            subTitle && (React.createElement(Typography, { variant: "body1", color: "textSecondary", fontSize: subTitleFS }, subTitle)))));
};
export default CommonHeader;
